// eslint-disable-next-line boundaries/dependencies
import { useEnvironmentVariables } from 'app-kit'
import { useMemo } from 'react'

/**
 * Utility functions for uploading files to signed URLs
 * Handles environment-specific headers (Azure vs GCP)
 */

/**
 * Get upload headers for signed URL requests
 * Adds Azure-specific headers when in ADNOC/Azure environment
 */
export const getSignedUrlUploadHeaders = (
  isAdnocEnvironment: boolean
): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/octet-stream',
  }

  // Add Azure-specific blob type header for ADNOC environment
  if (isAdnocEnvironment) {
    headers['x-ms-blob-type'] = 'BlockBlob'
  }

  return headers
}

/**
 * Hook to get signed URL upload headers based on current environment
 */
export const useSignedUrlUploadHeaders = () => {
  const { IS_ADNOC_ENVIRONMENT } = useEnvironmentVariables()
  return useMemo(
    () => getSignedUrlUploadHeaders(IS_ADNOC_ENVIRONMENT),
    [IS_ADNOC_ENVIRONMENT]
  )
}
